import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ubs-ofbiz-summary-list',
  templateUrl: './ofbiz-summary-list.component.html',
  styleUrls: ['./ofbiz-summary-list.component.scss']
})
export class OfbizSummaryListComponent implements OnInit {
  @Input() summaryView:any;
  @Input() existingValues:any;
  @Input() fieldList:any[];
  
  constructor() { }

  ngOnInit(): void {
    console.log({summaryView:this.summaryView})
  }

}
